import { ApiComm } from '../comm';
import { ResponseDTO } from '../dto/ResponseDTO';
import { BannerInfoDTO } from '../dto/BannerManagementDTOs';
import { BannerType } from '../common/enums';
import { genNoobookHeader } from './Common';
import { BannerInputReqDTO } from '../dto/BannerManagementDTOs';
import { NoobookFileInfoDTO } from '../dto/CommonDTOs';
//import { NoobookUtils } from '../utils/NoobookUtils';


export function getBannerList(authToken:string
  , writerNmOrId:string, bannerType:BannerType
  , title:string, active:boolean|null
  , createdAtFr:Date, createdAtTo:Date
  , page:number, size:number):Promise<ResponseDTO<BannerInfoDTO[]>>{
	return ApiComm.getData<ResponseDTO<BannerInfoDTO[]>>(`/close/v1/admin/banner/list`
		, {writerNmOrId:writerNmOrId, bannerType:bannerType, title:title, active:active, createdAtFr:createdAtFr, createdAtTo:createdAtTo, page:page, size:size}
		, genNoobookHeader(authToken, null, 'application/json', 'app')
	).then(resp=>resp.data);
}


export function createBanner(authToken:string, reqDto:BannerInputReqDTO):Promise<ResponseDTO<BannerInfoDTO>>{
	return ApiComm.postData<ResponseDTO<BannerInfoDTO>>(`/close/v1/admin/banner`
		, reqDto
		, genNoobookHeader(authToken, null, 'application/json', 'app')
	).then(resp=>resp.data);
}


export function modifyBanner(authToken:string, bannerId:number, reqDto:BannerInputReqDTO):Promise<ResponseDTO<BannerInfoDTO>>{
	return ApiComm.putData<ResponseDTO<BannerInfoDTO>>(`/close/v1/admin/banner/${bannerId}`
		, reqDto
		, genNoobookHeader(authToken, null, 'application/json', 'app')
	).then(resp=>resp.data);
}

export function getBanner(authToken:string, bannerId:number):Promise<ResponseDTO<BannerInfoDTO>>{
	return ApiComm.getData<ResponseDTO<BannerInfoDTO>>(`/close/v1/admin/banner/${bannerId}`
		, {}
		, genNoobookHeader(authToken, null, 'application/json', 'app')
	).then(resp=>resp.data);
}


export function deleteBanner(authToken:string, bannerId:number):Promise<ResponseDTO<BannerInfoDTO>>{
	return ApiComm.deleteData<ResponseDTO<BannerInfoDTO>>(`/close/v1/admin/banner/${bannerId}`
		, {}
		, genNoobookHeader(authToken, null, 'application/json', 'app')
	).then(resp=>resp.data);
}


export function uploadBannerToTempFile(authToken:string
		, file:File): Promise<ResponseDTO<NoobookFileInfoDTO>> {
	return ApiComm.postFormData<ResponseDTO<NoobookFileInfoDTO>>(`/close/v1/admin/banner/image`
		, {file:file}
		, genNoobookHeader(authToken, null, 'multipart/form-data', 'app')
	).then(resp=>resp.data);
}

